import type {
	Components,
} from '@mui/material'

export const materialUIPaperTheme: {
	components: Components
} = {
	components: {
		MuiPaper: {
			styleOverrides: {
			},
		},
	},
}
